const IconModalOk = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="35"
      height="35"
      viewBox="0 0 50 50"
      className="mr-2"
    >
      <g
        id="Icon_ionic-ios-checkmark-circle-outline"
        data-name="Icon ionic-ios-checkmark-circle-outline"
        transform="translate(-3.375 -3.375)"
      >
        <path
          id="Path_19"
          data-name="Path 19"
          d="M36.18,14.526,34.064,12.35a.455.455,0,0,0-.337-.144h0a.436.436,0,0,0-.337.144L18.728,27.122l-5.337-5.337a.465.465,0,0,0-.673,0l-2.139,2.139a.479.479,0,0,0,0,.685l6.731,6.731a2.129,2.129,0,0,0,1.406.685,2.23,2.23,0,0,0,1.394-.661h.012l16.07-16.154A.514.514,0,0,0,36.18,14.526Z"
          transform="translate(5.008 6.265)"
          fill="#2dc361"
        />
        <path
          id="Path_20"
          data-name="Path 20"
          d="M28.375,6.74a21.638,21.638,0,0,1,15.3,36.935,21.638,21.638,0,0,1-30.6-30.6,21.491,21.491,0,0,1,15.3-6.334m0-3.365a25,25,0,1,0,25,25,25,25,0,0,0-25-25Z"
          fill="#2dc361"
        />
      </g>
    </svg>
  );
};
export default IconModalOk;
